import Settings from '@/admin/pages/settings/settings';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/settings')({
	component: Settings,
});
